module.exports = __webpack_public_path__ + "img/condey.459ffb8a.png";